import { useTranslation } from 'react-i18next';

/** Loading placeholder shaped like a detail page (header, KPIs, one section). */
export default function DetailSkeleton({ kpis = 4 }: { kpis?: number }) {
  const { t } = useTranslation();
  return (
    <div className="max-w-7xl space-y-6" aria-busy="true" aria-live="polite">
      <span className="sr-only">{t('common.loading')}</span>
      <div className="space-y-3">
        <div className="skeleton h-4 w-40" />
        <div className="skeleton h-7 w-72 max-w-full" />
        <div className="flex gap-8">
          <div className="skeleton h-8 w-24" />
          <div className="skeleton h-8 w-24" />
          <div className="skeleton h-8 w-24" />
        </div>
      </div>
      {kpis > 0 && (
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-3">
          {Array.from({ length: kpis }).map((_, i) => <div key={i} className="skeleton h-24 rounded-xl" />)}
        </div>
      )}
      <div className="bg-surface-0 border border-surface-200 rounded-xl p-5 space-y-4">
        <div className="skeleton h-5 w-40" />
        {[1, 2, 3, 4].map((i) => <div key={i} className="skeleton h-4 w-full" />)}
      </div>
    </div>
  );
}
